
/**
 * 2D view matrix calculations.
 */

const mathjs = require("mathjs");


const identity_matrix = () => {
  return mathjs.identity(3);
};

const create_translate_matrix = (tx, ty) => {
  let result = identity_matrix();
  result.set([0, 2], tx);
  result.set([1, 2], ty);
  return result;
};

const create_scale_matrix = (sx, sy) => {
  let result = identity_matrix();
  result.set([0, 0], sx);
  result.set([1, 1], sy);
  return result;
};

const create_rotation_matrix = theta => {
  let result = identity_matrix();
  let c = Math.cos(theta);
  let s = Math.sin(theta);
  result.set([0, 0], c);
  result.set([0, 1], -s);
  result.set([1, 0], s);
  result.set([1, 1], c);
  return result;
};

const invert_matrix = matrix => {
  return mathjs.inv(matrix);
};

const rotate_about_pos = (theta, px, py) => {
  return mathjs.multiply(
    create_translate_matrix(px, py),
    create_rotation_matrix(theta),
    create_translate_matrix(-px, -py),
  );
};

const scale_about_pos = (sx, sy, px, py) => {
  return mathjs.multiply(
    create_translate_matrix(px, py),
    create_scale_matrix(sx, sy),
    create_translate_matrix(-px, -py));
};

const translate_matrix = (matrix, tx, ty) => {
  return mathjs.multiply(matrix, create_translate_matrix(tx, ty));
};

const scale_matrix = (matrix, sx, sy, px, py) => {
  return mathjs.multiply(matrix, scale_about_pos(sx, sy, px, py));
};

/**
 *
 * @param matrix
 * @param pt: {x: float, y: float}
 * @return {{x, y}}
 */
const transform_point = (matrix, pt) => {
  let result = mathjs.multiply(matrix, [pt.x, pt.y, 1]);
  return {
    x: result.get([0]),
    y: result.get([1]),
  }
};

/**
 * @param matrix
 * @param pts: [{x: float, y: float}]
 */
const transform_points = (matrix, pts) => {
  return pts.map(pt => {
    return transform_points(matrix, pt);
  })
};

const transform_x = (matrix, x) => {
  let result = mathjs.multiply(matrix, [x, 0, 1]);
  return result.get([0]);
};

const transform_y = (matrix, y) => {
  let result = mathjs.multiply(matrix, [0, y, 1]);
  return result.get([1]);
};

const matrix_test = () => {
  let id = identity_matrix();
  console.log("id", id.toString());
  let trans = create_translate_matrix(1, 2);
  console.log("trans", trans.toString());

  let r0 = mathjs.multiply(id, trans, trans, trans);
  console.log("r0", r0.toString());
  r0 = mathjs.multiply(r0, trans);
  console.log("r0", r0.toString());

  let result = mathjs.multiply(r0, [1, 2, 1]);
  console.log("result", result.toString());
  console.log("matrix", result, result.get([0]), result.get([1]));
};


export { identity_matrix, translate_matrix, matrix_test, scale_matrix,
  invert_matrix, transform_point, transform_points, transform_x,
  transform_y, rotate_about_pos, scale_about_pos, create_translate_matrix }
